
import { getAdminToken } from 'eco-design-micro/utils-user/admin/adminToken';
import { getReqHeaders } from 'eco-design-micro/utils/getReqHeaders';
import { getBaseUrl } from 'eco-design-reliance/getBaseUrl';
import { FetchOptionProps, QueryParamsA } from './FetchConstant';

// post-web
export const fetchGetWeb = async (url: string, params: QueryParamsA | null, options: FetchOptionProps) => {
    const options2 = options || {};
    const locale = options2.locale;
    const headers1 = options2.headers;

    const headers2 = getReqHeaders(locale);
    const headers = {
        ...headers1,
        ...headers2,
    };
    if (options2.token) {
        headers['Authorization'] = `Bearer ${options2.token}`;
    }
    const API_HOST_WEB = getBaseUrl(locale);
    try {
        const res = await fetch(`${API_HOST_WEB}${url}`, {
            method: 'GET',
            headers: headers as any,
        });
        return await res.json();
    } catch (error) { }
    return {};
};

// post-web
export const fetchPostWeb = async (url: string, params: QueryParamsA | null, options: FetchOptionProps) => {
    const options2 = options || {};
    const locale = options2.locale;
    const headers1 = options2.headers;

    const headers2 = getReqHeaders(locale);
    const headers = {
        ...headers1,
        ...headers2,
    };
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    if (options2.token) {
        headers['Authorization'] = `Bearer ${options2.token}`;
    }
    const API_HOST_WEB = getBaseUrl(locale);
    try {
        const res = await fetch(`${API_HOST_WEB}${url}`, {
            method: 'POST',
            headers: headers as any,
            body: JSON.stringify(params || {}),
        });
        return await res.json();
    } catch (error) { }
    return {};
};

// get-admin
export const fetchGetAdmin = async (url: string, params: QueryParamsA | null, options: FetchOptionProps) => {
    const options2 = options || {};
    const locale = options2.locale;
    const headers1 = options2.headers;

    const headers2 = getReqHeaders(locale);
    const headers = {
        ...headers1,
        ...headers2,
    };
    const adminToken = getAdminToken(locale);
    headers['Authorization'] = `Bearer ${adminToken}`; //统一登录token
    const API_HOST_WEB = getBaseUrl(locale);
    try {
        const resA = await fetch(`${API_HOST_WEB}${url}`, {
            method: 'GET',
            headers: headers as any,
        });
        const dataA = await resA.json();
        return dataA;
    } catch (error) { }
    return {};
};

// post-admin
export const fetchPostAdmin = async (url: string, params: QueryParamsA | null, options: FetchOptionProps) => {
    const options2 = options || {};
    const locale = options2.locale;
    const headers1 = options2.headers;

    const headers2 = getReqHeaders(locale);
    const headers = {
        ...headers1,
        ...headers2,
    };
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    const adminToken = getAdminToken(locale);
    headers['Authorization'] = `Bearer ${adminToken}`; //统一登录token
    const API_HOST_WEB = getBaseUrl(locale);
    try {
        const resA = await fetch(`${API_HOST_WEB}${url}`, {
            method: 'POST',
            headers: headers as any,
            body: JSON.stringify(params || {}),
        });
        const dataA = await resA.json();
        return dataA;
    } catch (error) { }
    return {};
};

// put-admin
export const fetchPostPut = async (url: string, params: QueryParamsA | null, options: FetchOptionProps) => {
    const options2 = options || {};
    const locale = options2.locale;
    const headers1 = options2.headers;

    const headers2 = getReqHeaders(locale);
    const headers = {
        ...headers1,
        ...headers2,
    };
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    const adminToken = getAdminToken(locale);
    headers['Authorization'] = `Bearer ${adminToken}`; //统一登录token
    const API_HOST_WEB = getBaseUrl(locale);
    try {
        const resA = await fetch(`${API_HOST_WEB}${url}`, {
            method: 'PUT',
            headers: headers as any,
            body: JSON.stringify(params || {}),
        });
        const dataA = await resA.json();
        return dataA;
    } catch (error) { }
    return {};
};
